export enum TRACK_TYPE {
    Inverted = "inverted",
    Normal = "normal"
}
